import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IVenueResponse } from './venue.models';

@Injectable()
export class VenueService {
    private _http = inject(HttpClient);

    public getVenueById(
        venueId: string
    ): Observable<IVenueResponse> {
        return this._http.get<IVenueResponse>(`venues/${venueId}?withfieldofplay=true`);
    }

    public getSportSurfaceSvg(url: string): Observable<string> {
        return this._http.get(url, { responseType: 'text' });
    }
}
